import { Dot } from "lucide-react";
import { cn } from "@eduviaos/ui-kit";
import { Reveal, SectionCard, SectionHeader } from "../../components/Section";
import { COACHING_TESTS } from "../../lib/verticalData";

const STATUS_STYLE: Record<string, { label: string; className: string }> = {
  live: { label: "Live", className: "bg-joy-rose/15 text-joy-rose" },
  upcoming: { label: "Upcoming", className: "bg-joy-indigo/12 text-joy-indigo" },
  done: { label: "Attempted", className: "bg-joy-green/12 text-joy-green" },
};

/** Coaching "Tests" tab — the full test-series list. */
export function TestsPanel() {
  return (
    <Reveal>
      <SectionHeader title="Test Series" />
      <div className="space-y-3">
        {COACHING_TESTS.map((t) => {
          const s = STATUS_STYLE[t.status]!;
          return (
            <SectionCard key={t.title} className="flex items-center gap-3">
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-semibold">{t.title}</p>
                <p className="text-muted-foreground flex items-center gap-0.5 text-xs">
                  {t.when} <Dot className="size-3" /> {t.questions} Q
                  {t.score ? ` · ${t.score}` : ""}
                </p>
              </div>
              <span
                className={cn(
                  "shrink-0 rounded-full px-2.5 py-1 text-[0.68rem] font-semibold",
                  s.className,
                )}
              >
                {s.label}
              </span>
            </SectionCard>
          );
        })}
      </div>
    </Reveal>
  );
}
